import api from './apiClient';
import { OnboardingSuggestion, OnboardingSuggestionRequest, PetInsightSummary, PetOnboardingDraft, AIUsageInfo } from '../types';

export const petAIService = {
  generateSuggestion: async (
    payload: OnboardingSuggestionRequest,
    petId?: number
  ): Promise<OnboardingSuggestion> => {
    const params = petId ? { pet_id: petId } : {};
    const response = await api.post('/pets/ai/suggestion', payload, { params });
    return response.data;
  },
  
  getUsage: async (petId?: number): Promise<AIUsageInfo> => {
    const params = petId ? { pet_id: petId } : {};
    const response = await api.get('/pets/ai/usage', { params });
    return response.data;
  },
  
  /** Resumen clínico. No enviar regenerate=true salvo en botón "Regenerar"; abrir/recargar no debe consumir uso. */
  getPetInsightSummary: async (id: number, year?: number, regenerate = false): Promise<PetInsightSummary> => {
    const params: Record<string, string | number> = { regenerate: regenerate ? 'true' : 'false' };
    if (year !== undefined && year !== null) {
      params.year = year;
    }
    const response = await api.get(`/pets/${id}/insights/summary`, { params });
    return response.data;
  },
  
  saveDraft: async (formResponses: any, draftUuid?: string): Promise<PetOnboardingDraft> => {
    const response = await api.post('/pets/ai/draft', {
      form_responses: formResponses,
      draft_uuid: draftUuid,
    });
    return response.data;
  },
  
  markDraftAsCompleted: async (draftUuid: string): Promise<void> => {
    await api.patch('/pets/ai/draft/complete', null, {
      params: { draft_uuid: draftUuid },
    });
  },
  
  getDraft: async (draftUuid?: string): Promise<PetOnboardingDraft | null> => {
    try {
      const params = draftUuid ? { draft_uuid: draftUuid } : {};
      const response = await api.get('/pets/ai/draft', { params });
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },
  
  getAllDrafts: async (): Promise<PetOnboardingDraft[]> => {
    const response = await api.get('/pets/ai/drafts');
    return response.data;
  },
  
  deleteDraft: async (draftUuid: string): Promise<void> => {
    await api.delete('/pets/ai/draft', { params: { draft_uuid: draftUuid } });
  },
  
  refreshDraftsExpiration: async (): Promise<{ message: string; updated_count: number; expiration_days: number }> => {
    const response = await api.patch('/pets/ai/drafts/refresh-expiration');
    return response.data;
  },
};








